import React, {Component} from 'react';
import Header from './../Layout/Header';
import Footer from './../Layout/Footer2';
import { Helmet } from 'react-helmet';

import ByCountry from './../Element/ByCountry';
import ByCity from './../Element/ByCity';
import ByState from './../Element/ByState';

class AllJobsByLocation extends Component {
    render() {
        return (
            <div className="page-wraper">
                <Header />

                <Helmet>
                    <title>Remote Jobs by Location | Work From Home Opportunities | OpenToWorkRemote</title>
                    <meta name="description" content="Find remote jobs and work from home opportunities worldwide. Search by country, state, or city. Access thousands of remote positions from top companies. Updated daily. #RemoteWork #WorkFromHome" />
                    <meta name="keywords" content="remote jobs, work from home, remote work opportunities, remote positions, remote career, remote employment, virtual jobs" />
                    <meta property="og:title" content="Remote Jobs by Location | OpenToWorkRemote" />
                    <meta property="og:description" content="Find remote jobs and work from home opportunities worldwide. Search by country, state, or city." />
                    <link rel="canonical" href="https://www.opentoworkremote.com/all-jobs-by-location" />
                </Helmet>

                <ByCountry />

                <ByState />

                <ByCity />

                <Footer />
            </div>
        );
    }
};

export default AllJobsByLocation;
